/* eslint-disable no-undef */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { Provider } from 'react-redux';

// Enable this import for development logging
// import { store } from '../../redux/store.dev.js';

// Enable this import for production builds
import { store } from '../../redux/store.prod.js';

const react_app_wrapper = document.querySelector("#online-form__app-wrapper");

// Don't run on a non-React page
if (react_app_wrapper !== null) {
  const root = createRoot(react_app_wrapper);

  // Get the form configuration values
  const dynamicFormConfiguration = {
    formContentJsonEndpoint: react_app_wrapper.getAttribute('data-form-content-json-endpoint'),
    formCalculationsJsonEndpoint: react_app_wrapper.getAttribute('data-form-calculations-json-endpoint'),
    testingButton: (react_app_wrapper.getAttribute('data-testing-button') === "true") ? true : false
  };

  root.render(
    <Provider store={store}>
      <React.StrictMode>
        <div>
          <App configuration={dynamicFormConfiguration} />
        </div>
      </React.StrictMode>
    </Provider>
  );
}